import type { FormValues, UseFormValuesEffectProps } from "./form.type";

import { Form } from "antd";
import isEqual from "lodash/isEqual";
import { useEffect, useRef } from "react";

const { useFormInstance, useWatch } = Form;

export const useFormWatchField = (fieldName: string) => {
  const form = useFormInstance();

  // Ant Design `useWatch()` do not return initial value
  return useWatch(fieldName, form) ?? form.getFieldValue(fieldName);
};

export const useFormValuesEffect = <Values extends FormValues>({
  form,
  onValuesChange,
}: UseFormValuesEffectProps<Values>) => {
  const values = useWatch([], { form, preserve: true });
  const prevValuesRef = useRef<Values>();

  useEffect(() => {
    if (!values) return;
    if (isEqual(prevValuesRef.current, values)) return;

    prevValuesRef.current = values;
    onValuesChange?.(values);
  }, [values, onValuesChange]);

  return {
    values: values ?? {},
  };
};
